"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCheckbox = withCheckbox;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withCheckboxModule = _interopRequireDefault(require("./with-checkbox.module.scss"));
function withCheckbox(TableCellComponent) {
  var TableCellWithCheckbox = function TableCellWithCheckbox(props) {
    return /*#__PURE__*/_react.default.createElement(TableCellComponent, props);
  };
  TableCellWithCheckbox.Header = function (props) {
    return /*#__PURE__*/_react.default.createElement(TableCellComponent.Header, Object.assign({}, props, {
      className: (0, _classnames.default)(props.className, _withCheckboxModule.default['with-checkbox'])
    }));
  };
  TableCellWithCheckbox.Header.displayName = "withCheckbox(".concat(TableCellComponent.Header.displayName, ")");
  TableCellWithCheckbox.Loading = function (props) {
    return /*#__PURE__*/_react.default.createElement(TableCellComponent.Loading, Object.assign({}, props, {
      className: (0, _classnames.default)(props.className, _withCheckboxModule.default['with-checkbox'])
    }));
  };
  TableCellWithCheckbox.Loading.displayName = "withCheckbox(".concat(TableCellComponent.Loading.displayName, ")");
  return TableCellWithCheckbox;
}